module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Help")]), _vm._v(" "), _c('ul', {
    staticClass: "articles"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/buy'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite dollar_currency_sign",
    attrs: {
      "title": "Buy Picks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/buy'
      }
    }
  }, [_vm._v("Buy Picks")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("The dollar sign takes you to the buy picks screen.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/testimonials'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite user",
    attrs: {
      "title": "Testimonials"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/testimonials'
      }
    }
  }, [_vm._v("Testimonials")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("The user takes you to the testimonials screen.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/picks'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite lock",
    attrs: {
      "title": "View Picks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/picks'
      }
    }
  }, [_vm._v("View Picks")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("The lock takes you to the testimonials screen.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/blog'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite email",
    attrs: {
      "title": "Blog"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/blog'
      }
    }
  }, [_vm._v("Blog")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("The @ sign takes you to the blog.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/tools/size'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite chart_up",
    attrs: {
      "title": "Bet Calculator"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/tools/size'
      }
    }
  }, [_vm._v("Bet Calculator")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("This icon takes you to the bet calculator.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/contact'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite mail",
    attrs: {
      "title": "Contact Us"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/contact'
      }
    }
  }, [_vm._v("Contact")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("The mail icon takes you to the contact page")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": "/static/images/Go_Out.png",
      "width": "38px",
      "height": "38px",
      "alt": "Logout"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "title_article"
  }, [_vm._v("Logout")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("This icon will log you out of the website.")])]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e23b179"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help.vue
// module id = 284
// module chunks = 1